document.addEventListener('click', e=>{
  const t = e.target.closest('[data-drawer-open]');
  if(t){document.getElementById('mobile-drawer').classList.add('open')}
  const c = e.target.closest('[data-drawer-close]');
  if(c){document.getElementById('mobile-drawer').classList.remove('open')}
});

/* Product slideshow */
document.querySelectorAll('[data-kp-slideshow]').forEach(function(root){
  var track = root.querySelector('.product__track');
  var slides = root.querySelectorAll('.product__slide');
  var dots = root.querySelectorAll('.product__dot');
  var prev = root.querySelector('.product__nav--prev');
  var next = root.querySelector('.product__nav--next');
  if(!track || slides.length < 2) return;
  function go(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior:'smooth' });
  }
  function current(){
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }
  prev && prev.addEventListener('click', function(){ go(current()-1); });
  next && next.addEventListener('click', function(){ go(current()+1); });
  dots.forEach(function(d,i){ d.addEventListener('click', function(){ go(i); }); });
  track.addEventListener('scroll', function(){
    var i = current();
    dots.forEach(function(d,j){ d.classList.toggle('is-active', j===i); });
  }, { passive:true });
});

/* Homepage collection slideshow */
document.querySelectorAll('[data-kp-collection]').forEach(function(root){
  var track = root.querySelector('.kp-collection-track');
  var slides = root.querySelectorAll('.kp-collection-slide');
  var prev = root.querySelector('.kp-coll-nav--prev');
  var next = root.querySelector('.kp-coll-nav--next');
  var dotsWrap = root.querySelector('.kp-coll-dots');
  if(!track || slides.length === 0) return;
  if(slides.length < 2){
    prev && (prev.style.display='none');
    next && (next.style.display='none');
    dotsWrap && (dotsWrap.style.display='none');
    return;
  }
  // build dots
  var dots = [];
  for(var i=0;i<slides.length;i++){
    var b = document.createElement('button');
    b.type='button'; b.setAttribute('aria-label','Go to slide '+(i+1));
    if(i===0) b.className='is-active';
    (function(idx){ b.addEventListener('click', function(){ go(idx); }); })(i);
    dotsWrap.appendChild(b); dots.push(b);
  }
  function go(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior:'smooth' });
  }
  function current(){
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }
  prev.addEventListener('click', function(){ go(current()-1); });
  next.addEventListener('click', function(){ go(current()+1); });
  track.addEventListener('scroll', function(){
    var i = current();
    dots.forEach(function(d,j){ d.classList.toggle('is-active', j===i); });
  }, { passive:true });
});
